import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
    translateDataSourceResultGroups,
    DataResult,
    DataSourceRequestState
} from '@progress/kendo-data-query';
import { GridDataResult} from '@progress/kendo-angular-grid';
import { Observable, of } from 'rxjs';
import 'rxjs/add/operator/map';

@Injectable()
export class DataService {
constructor(
    ) { }

public fetchCustomer(custData,state: DataSourceRequestState): Observable<DataResult> {
    const hasGroups = state.group && state.group.length;
    return of({data:(custData.Customers !=undefined ?custData.Customers :custData.JobSites),total:custData.Count}) // Send the state to the server
    .map(({data, total} : GridDataResult) => // Process the response
        (<GridDataResult>{
            data: hasGroups ? translateDataSourceResultGroups(data) : data,
            total: total,
        }))
    }   
}